import { Card, Text, BlockStack, InlineStack } from '@shopify/polaris';

interface KPICardProps {
  title: string;
  value: string | number;
  suffix?: string;
  trend?: string;
  trendUp?: boolean;
  change?: number | null; // percentage change vs previous period
}

export default function KPICard({ title, value, suffix, trend, trendUp, change }: KPICardProps) {
  const hasChange = change !== undefined && change !== null && isFinite(change);

  return (
    <Card>
      <BlockStack gap="200">
        <Text as="p" variant="bodySm" tone="subdued">
          {title}
        </Text>
        <InlineStack align="start" blockAlign="baseline" gap="200">
          <Text as="p" variant="headingXl" fontWeight="bold">
            {typeof value === 'number' ? value.toLocaleString() : value}
          </Text>
          {suffix && (
            <Text as="p" variant="bodySm" tone="subdued">
              {suffix}
            </Text>
          )}
        </InlineStack>
        {hasChange && (
          <Text
            as="p"
            variant="bodySm"
            tone={change >= 0 ? 'success' : 'critical'}
          >
            {change >= 0 ? '↑' : '↓'} {Math.abs(change).toFixed(1)}% vs prev 30d
          </Text>
        )}
        {trend && (
          <Text
            as="p"
            variant="bodySm"
            tone={trendUp ? 'success' : 'critical'}
          >
            {trend}
          </Text>
        )}
      </BlockStack>
    </Card>
  );
}
